import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface HelpIconProps {
  title: string;
  body: React.ReactNode;
  ariaLabel?: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({ title, body, ariaLabel }) => (
  <Tooltip
    arrow
    placement="top"
    enterTouchDelay={0}
    title={
      <Box sx={{ maxWidth: 360, p: 0.25 }}>
        <Box sx={{ fontWeight: 950, mb: 0.5, color: "#0B2230" }}>{title}</Box>
        <Box sx={{ color: "rgba(11,34,48,0.78)", lineHeight: 1.55 }}>{body}</Box>
      </Box>
    }
  >
    <IconButton
      size="small"
      aria-label={ariaLabel || `${title} info`}
      sx={{
        ml: 0.5,
        color: "#176B87",
        border: "1px solid rgba(134,182,246,0.7)",
        backgroundColor: "rgba(255,255,255,0.7)",
        "&:hover": { backgroundColor: "rgba(255,255,255,0.95)" },
      }}
    >
      <InfoOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);

export default HelpIcon;
